import { ArticlePaginated } from 'types/ArticleTypes';
import useHttp from '../helpers/HttpMethods';

class KbFolderArticlesService {
  static async list(
    kbFolderId: number,
    filters: string
  ): Promise<Response | ArticlePaginated> {
    return useHttp().get(`/kb-folders/${kbFolderId}/articles?${filters}`);
  }
}

export default KbFolderArticlesService;
